import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const userQuestionsAdapter = createEntityAdapter({
    sortComparer: (a, b) => (a.completed === b.completed) ? 0 : a.completed ? 1 : -1
})

const initialState = userQuestionsAdapter.getInitialState()

export const userQuestionsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserQuestions: builder.query({
            query: () => ({
                url: '/api/user-question',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedUserQuestions = responseData.map(userQuestion => {
                    userQuestion.id = userQuestion._id
                    return userQuestion
                });
                return userQuestionsAdapter.setAll(initialState, loadedUserQuestions)
            },
            providesTags: ['UserQuestionList'],
        }),
        getUserQuestionsForAdmin: builder.query({
            query: ({groupId}) => ({
                url: `/api/user-question/report/${groupId}`,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            // transformResponse: responseData => {
            //     const loadedUserQuestions = responseData.map(userQuestion => {
            //         userQuestion.id = userQuestion._id
            //         return userQuestion
            //     });
            //     return userQuestionsAdapter.setAll(initialState, loadedUserQuestions)
            // },
            providesTags: ['UserQuestionListAdmin'],
        }),
        getCurrentQuestion: builder.query({
            query: ({ userQuestionId,userSelectedQuestion }) => ({
                url: `/api/user-question/${userQuestionId}/${userSelectedQuestion?'?userSelectedQuestion=' +userSelectedQuestion:''}`,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            providesTags: ['CurrQuestion'],
        }),
       answerUserQuestion: builder.mutation({
            query: initialUserQuestion => ({
                url: '/api/user-question',
                method: 'PATCH',
                body: {
                    ...initialUserQuestion,
                }
            }),
            invalidatesTags: ['CurrQuestion', 'UserQuestionList'],
        }), 
    }),
})

export const {
    useGetUserQuestionsQuery,
    useGetCurrentQuestionQuery,  
    useLazyGetCurrentQuestionQuery, 
    useAnswerUserQuestionMutation,
    useGetUserQuestionsForAdminQuery
} = userQuestionsApiSlice

// returns the query result object
export const selectUserQuestionsResult = userQuestionsApiSlice.endpoints.getUserQuestions.select()

// creates memoized selector
const selectUserQuestionsData = createSelector(
    selectUserQuestionsResult,
    userQuestionsResult => userQuestionsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserQuestions,
    selectById: selectUserQuestionById,
    selectIds: selectUserQuestionIds
    // Pass in a selector that returns the userQuestions slice of state
} = userQuestionsAdapter.getSelectors(state => selectUserQuestionsData(state) ?? initialState)